import React from 'react';
import { Link } from 'react-router-dom';


const Pricing = () => {
  return (
    <div className="pricing" id="pricing">
      {/* <div className="dots dots-up"></div>
      <div className="dots dots-down"></div> */}
      <h2 className="main-title">Education Background</h2>
      <img src="imgs/Mohamed abi.png" alt="" />
      <div className="container">
        <div className="box popular">
          <div className="label">Background</div>
          <div className="title heading box-title">Education Background</div>
          
          <h2> Bachelor degree in computer science Engineering</h2>  
          <ul style={{"text-align":"center"}}>
            <li> Bachelor degree in computer science Engineering 
               Bachelor's degree in Computer Science Engineering. Over the past three years, I have been
                exploring various concepts related to computer science, 
                such as algorithms and information systems. During this time,
                 I have also honed my skills in web development using Python and the Django library to design 
                 databases for websites. Additionally, I have experience in using React to develop interactive user interfaces,
                  and I have participated in various computer science </li>
                <img style={{"width":"40%"}}src="imgs/Licence_page-0001.jpg"></img>
          
          </ul>
          <h2>DATA SCIENCE </h2>  
          <ul style={{"text-align":"center"}}>
            <li> First year Of spcialisation Year (Current)</li>
          </ul>

          <Link to="/certifications">certifications</Link>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
